import React from 'react';

const SvgAe = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="AE_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="AE_svg__b" fill="#fff">
        <use xlinkHref="#AE_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#12833B" mask="url(#AE_svg__b)" d="M8 0h20v6.667H8z" />
      <path fill="#262626" mask="url(#AE_svg__b)" d="M8 13.333h20V20H8z" />
      <path fill="#FF323E" mask="url(#AE_svg__b)" d="M0 0h8v20H0z" />
    </g>
  </svg>
);

export default SvgAe;
